"use client";

import { useAuthRedirect } from "@/hooks/useAuthRedirect";

export default function AuthRedirect({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isInitialized, shouldRender } = useAuthRedirect();

  // Show loading state while auth is initializing
  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500" />
      </div>
    );
  }

  // Don't render anything while redirecting
  if (!shouldRender) {
    return null;
  }

  // Render children if redirection is not required
  return <>{children}</>;
}
